<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element find-the-picture-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      @if (passagesSubTask) {
        <button class="open-passage" [disabled]="disableAVButtons" (click)="togglePassage()"></button>
      }
      @if (passagesSubTask) {
        <div class="passage-title font-27"> {{passageTitle}} </div>
      }
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()"
      [disabled]="disableNextButton && disableResponseButtons"></button>
    </div>
    <div class="word-to">
      <div class="audio-controls-container find-the-picture-speaker-position">
        @if (showResponseAudioButtons || (isSecondGradeOrLess && passagesSubTask)) {
          <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
        }
        @if (showResponseAudioButtons || (isSecondGradeOrLess && passagesSubTask)) {
          <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons"></button>
        }
      </div>
      <div class="word-masked font-42">
        {{targetWord}}
      </div>
      @if (!unmaskedTask) {
        <button [class]="{'again-button-grayed' : disableAgainButton, 'again-button' : !disableAgainButton, 'toggle-again-on' : toggleAgainButton, 'again-button-hidden': hideAgainButton}"
          [disabled]="disableAgainButton"
          (click)="displayTrialAgain()">
        </button>
      }
    </div>
    <!-- Row for Next Trial button -->
    <div class="full-response-row">
      @if (!unmaskedTask) {
        <button [class]="{'next-button-grayed' : disableNextButton, 'next-button' : !disableNextButton, 'toggle-next-on' : toggleNextButton, 'next-button-hidden': hideNextButton}"
          [disabled]="disableNextButton"
          (click)="displayTrial()">
        </button>
      }
    </div>
    <!-- Row for picture response tiles -->
    @if (!hideResponses) {
      <div class="full-response-row-picture">
        @for (response of responseOptions; track response.text) {
          <div class="picture-button-div-intervention">
            @if (!showResponseAudioButtons) {
              <button class="ftp-letter-audio-hidden">
              </button>
            }
            @if (showResponseAudioButtons) {
              <button class="ftp-letter-audio" (click)="playPictureAudio(response.audio)" [disabled]="disableAVButtons">
              </button>
            }
            <button class="picture-response-block"
              [class.hover]="response.highlight"
              (click)="submitResponse($index)"
              [style]="{'border-color':' ' + interventionTaskService.highlightColor() + ' ', 'background-image':'url(' + response.imageUrl + ')' }"
              [disabled]="disableResponseButtons">
            </button>
          </div>
        }
      </div>
    }
  </div>

  @if (showPassageDialog) {
    <div class="try-again-dialog-background" [style.background]="' ' + interventionTaskService.taskBarColor() + ' '"></div>
  }
  @if (showPassageDialog) {
    <div class="passage-dialog-container" [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '">
      <button class="exit-passages-dialog" (click)="togglePassage()"></button>
      <div class="passages-target-area">
        <button class="speaker" (click)="playPassage()" [disabled]="disableAVButtons"></button>
        <div class="passages-target passages-dialog-target-adjust font-27">
          <button class="passages-title-audio" (click)="playTitle()"></button>
          {{passageTitle}}
        </div>
      </div>
      <!-- Container for sentences -->
      <div class="scrollable-sentence-container" id="{{'passage-scroll-' + currentDestination}}">
        @for (line of phrase; track line) {
          <div class="passages-line font-20">
            <button class="passages-line-audio" (click)="playLine(line['@audio'])"></button>
            {{line['#text']}}
          </div>
        }
      </div>
    </div>
  }
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
